module.exports = __webpack_public_path__ + "img/br.68c8404.svg";